module.exports = __webpack_public_path__ + "img/ipad.17590fec.png";